import React, { useState, forwardRef, useRef } from 'react';
import Filter from '../../../Common/Filter/Filter';
import CommunityImg from '../../../Common/CommunityImg/CommunityImg';
import DesignCard from '../../../Common/DesignCard/DesignCard';
import useCreativeDesigns from '../../../hooks/useCreativeDesigns';
import { default as filterIcon } from '../../../../images/filterIcon.svg';
import { default as sortIcon } from '../../../../images/sortIcon.svg';
import './CreativeDesignList.scss';

const CreativeDesignList = forwardRef(({
  isCreativeDesignPage = false,
  limit }, ref) => {

  const CreativeDesignData = useCreativeDesigns();

  const {
    creativeDesigns: { nodes: creativeDesigns },
    creativeDesignStyle: { distinct: creativeDesignStyle },
    creativeDesignTemplateType: { distinct: creativeDesignTemplateType },
    creativeProductTypes: { distinct: productTypes }
  } = CreativeDesignData;

  const eventPartnerListRef = useRef(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [displayDesignList, setDisplayDesignList] = useState(creativeDesigns);
  const [searchTerm, setSearchTerm] = useState('');
  const [designListLimit, setDesignListLimit] = useState(limit);
  const [productType, setProductType] = useState('All');
  const [designStyle, setDesignStyle] = useState('All');
  const [templateType, setTemplateType] = useState('All');

  const filterEventPartner = str => {
    const val = str.toLowerCase();
    const filterArr = creativeDesigns.filter(designs => designs.designTitle.toLowerCase().includes(val));
    setDisplayDesignList(filterArr);
  }

  const onSearchEventPartner = e => {
    const { target: { value } } = e;
    setSearchTerm(value);
    filterEventPartner(value);
  }

  const onCreativeDesignStyleFilter = (e) => {
    const value = e;
    setSearchTerm('');
    setDesignStyle(value);
    getFilteredData({ type: 'creativeDesignStyle', value });
  }

  const onCreativeDesignTemplateTypeFilter = (e) => {
    const value = e;
    setSearchTerm('');
    setTemplateType(value);
    getFilteredData({ type: 'creativeDesignTemplateType', value });
  }

  const onCreativeDesignProductTypeFilter = (e) => {
    const value = e;
    setSearchTerm('');
    setProductType(value);
    getFilteredData({ type: 'productType', value });
  }

  const getFilteredData = data => {
    const { type, value } = data;
    const tempCreativeDesigns = creativeDesigns
      .filter(item => {
        const tempVal = type === 'productType' ? value : productType;
        return tempVal !== 'All' ? item?.productType?.some(i => i === tempVal) : item;
      })
      .filter(item => {
        const tempVal = type === 'creativeDesignStyle' ? value : designStyle;
        return tempVal !== 'All' ? item?.designStyle?.some(i => i === tempVal) : item;
      })
      .filter(item => {
        const tempVal = type === 'creativeDesignTemplateType' ? value : templateType;
        return tempVal !== 'All' ? item?.designType?.some(i => i === tempVal) : item;
      });
    setDisplayDesignList(tempCreativeDesigns);
  }

  const onSort = (e) => {
    const value = e;
    if (value === 'A - Z') {
      displayDesignList.sort((a, b) => a.designTitle.localeCompare(b.designTitle));
      setDisplayDesignList([...displayDesignList]);
    } else if (value === 'Z - A') {
      displayDesignList.sort((a, b) => a.designTitle.localeCompare(b.designTitle)).reverse();
      setDisplayDesignList([...displayDesignList]);
    }
  }

  return (
    <div className={`creative-design-list-container ${isCreativeDesignPage && 'all-creative-design-page'}`} ref={ref}>
      <div className={`creative-design-list-filters-buttons ${!isFilterOpen && 'filters-button-closed'}`}>
        <div className="creative-design-list-filters-buttons-left">
          <button className={`btn ${isFilterOpen && 'filter-open'}`} onClick={() => setIsFilterOpen(!isFilterOpen)}>
            <CommunityImg src={filterIcon} alt="filter-button" />
            <span>Filter By</span>
          </button>
          <button className="btn" >
            <CommunityImg src={sortIcon} alt="sort-button" />
            {/* eslint-disable-next-line jsx-a11y/no-onchange*/}
            {/* <select ref={selectRef} onChange={onSort}>
              <option value="0">Sort By</option>
              <option value="3">A - Z</option>
              <option value="4">Z - A</option>
            </select> */}
            <Filter
              cls='creative-design-list-filters-sort-by'
              filterType="eventDate"
              defaultSelection="Sort By"
              alwaysShowDefaultSelection={true}
              width={380}
              filterData={['A - Z', 'Z - A']}
              onSelect={onSort}
            />
          </button>
        </div>
        <div className="creative-design-list-filters-buttons-right">
          <input
            value={searchTerm}
            type="text" id="fname"
            name="fname"
            placeholder="search our templates..."
            onChange={onSearchEventPartner}
          />
        </div>
      </div>
      {
        isFilterOpen &&
        <div className={`creative-design-list-filters ${isFilterOpen ? 'open' : ''}`}>
          <Filter
            cls='creative-design-list-filter'
            filterType="style"
            title="Style"
            width={330}
            filterData={['All', ...creativeDesignStyle]}
            onSelect={onCreativeDesignStyleFilter}
          />
          <Filter
            cls={`creative-design-list-filter ${productType === 'Card' ? '' : 'DisplayHidden'}`}
            filterType="templateType"
            title="Template Type"
            width={330}
            filterData={['All', ...creativeDesignTemplateType]}
            onSelect={onCreativeDesignTemplateTypeFilter}
          />
          <Filter
            cls='creative-design-list-filter'
            filterType="productType"
            title="Product"
            width={330}
            filterData={['All', ...productTypes]}
            onSelect={onCreativeDesignProductTypeFilter}
          />
        </div>
      }
      <div className="creative-design-list-list" ref={eventPartnerListRef}>
        <DesignCard limit={designListLimit} designs={[...displayDesignList]} isCreativeList={true} />
      </div>
      <div className="creative-design-list-seemore-button">
        {
          displayDesignList.length >= designListLimit && !isCreativeDesignPage &&
          <button onClick={()=>setDesignListLimit(designListLimit + 12)}>
            {/* <Link to='/creative-community/all-creative-design'> */}
              See More
            {/* </Link> */}
          </button>
        }
      </div>
    </div>
  )
})

export default CreativeDesignList;